<template>
  <v-data-table
    :headers="headers"
    :items="contacts"
    sort-by="id"
    class="elevation-1 dark-last-row"
    hide-default-footer
    item-key="id"
    :loading="loading"
    :expanded.sync="expanded"
    show-expand
  >
    <template v-slot:top>
      <v-toolbar
        flat
        color="accent"
      >
        <!--<v-toolbar-title class="white--text">Issues</v-toolbar-title>-->
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
          scrollable
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              tile
              small
            >
              <v-icon dark>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>
          <v-card flat color="accent">
            <v-card-title class="primary">
              <span class="title text-uppercase white--text">{{ formTitle }}</span>
            </v-card-title>

           <v-card-text class="pa-0">
              <ValidationObserver ref="observer1">
                <v-form ref="injuredsform">
                  <v-list flat color="accent" class="py-0">
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Name</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Name" rules="required">
                              <v-text-field
                                v-model="editedItem.name"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Company</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                              <v-text-field
                                v-model="editedItem.company"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Phone</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Phone" rules="required">
                              <v-text-field
                                v-model="editedItem.phone"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Email</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Email" rules="email|required">
                              <v-text-field
                                v-model="editedItem.email"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>              
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Contact Type</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Contact Type" rules="required">
                                  <v-text-field
                                    v-model="editedItem.type"
                                    :error-messages="errors"
                                    required
                                    solo
                                    flat
                                    dark
                                  ></v-text-field>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Notes</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Notes" rules="required">
                              <v-textarea
                                v-model="editedItem.notes"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                              ></v-textarea>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions class="accent">
              <v-btn
                large min-width="49%" color="white" text
                @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                large min-width="49%" color="primary" tile
                @click="save"
                :loading="loading"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card color="red">
            <v-card-title class="subtitle-2 justify-center white--text">Are you sure to delete this item?</v-card-title>
            <v-card-actions class="red darken-4">
              <v-spacer></v-spacer>
              <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">Yes</v-btn>
              <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn small color="secondary" tile @click="editItem(item)">      
        <v-icon
        >
          mdi-pencil
        </v-icon>
      </v-btn>             
      <v-btn small color="primary" tile @click="deleteItem(item)">
        <v-icon
        color="white"
        >
        mdi-delete
      </v-icon>  
      </v-btn>  
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        Notes: {{ item.notes }}
      </td>
    </template>
  </v-data-table>
</template>

<script>
    import { mapGetters } from 'vuex'
    import axios from 'axios'
    import { required, email } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import mixin from '../mixin/main.js'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    extend('email', {
      ...email,
      message: 'Email must be valid',
    })

    export default {
        mixins: [mixin],
        props: ['property'],
        data: () => ({
            loading: false,
            dialog: false,
            dialogDelete: false,
            expanded: [],
            singleExpand: false,
            headers: [
                {
                  text: 'Name',
                  align: 'start',
                  sortable: false,
                  value: 'name',
                },
                { text: 'Company', value: 'company', sortable: false },
                { text: 'Phone', value: 'phone', sortable: false },
                { text: 'Email', value: 'email', sortable: false },
                { text: 'Type', value: 'type', sortable: false },
                { text: 'Actions', value: 'actions', sortable: false, align: 'right' },
                { text: '', value: 'data-table-expand' },
            ],
            contacts: [],
            editedIndex: -1,
            editedItem: {
                id: '',
                name: '',
                company: '',
                phone: '',
                email: '',
                type: '',
                notes: '',
            },
            defaultItem: {
                id: '',
                name: '',
                company: '',
                phone: '',
                email: '',
                type: '',
                notes: '',
            },
        }),

        components: {
            ValidationProvider,
            ValidationObserver,
        },

        computed: {
            ...mapGetters({
                contact_types: 'data/contact_types',
            }),
            formTitle () {
                return this.editedIndex === -1 ? 'New Contact' : 'Edit Contact'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        created () {
            this.getContacts()
        },

        methods: {
            getContacts() {
                if(this.property) {
                    this.loading = true
                    axios.get('contacts/all?id=' + this.property)
                        .then(response => {
                            this.loading = false
                            this.contacts = response.data
                            this.$nextTick()
                        })
                }
            },

            editItem (item) {
                this.editedIndex = this.contacts.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                this.editedIndex = this.contacts.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.loading = true
                axios.delete('contacts/delete?id=' + this.editedItem.id)
                    .then(() => {
                      this.closeDelete()
                      this.getContacts()
                      this.$nextTick()
                    })
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            async save () {
                if (this.editedIndex > -1) {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      axios.post('contacts/update', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getContacts()
                          this.close()
                      }).catch(error => {
                          console.log(error)
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                } else {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      this.$set(this.editedItem, 'property_id', this.property)
                      axios.post('contacts/store', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getContacts()
                          this.close()
                      }).catch(error => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                }
            },
        },
    }
</script>